// extracted by mini-css-extract-plugin
export var fileUpload = "_fi-1";
export var modalButton = "_fi-0";